export const HEADER_ANALYTICS_EVENT_NAMES = {
  category: {
    nav: 'Primary Nav',
    menu: 'Primary Menu'
  }
}
